var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check-mark"},[_c('check-icon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }